import { render, staticRenderFns } from "./SnowballFight.vue?vue&type=template&id=3a920593"
import script from "./SnowballFight.vue?vue&type=script&lang=js"
export * from "./SnowballFight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports